import { Text as NativeText } from 'react-native'

import { styled } from 'nativewind'

export const M16 = styled(NativeText, 'font-[JioType-Medium] text-[16px]')

export const M20 = styled(NativeText, 'font-[JioType-Black]  text-[20px]')

export const M14 = styled(NativeText, 'font-[JioType-Medium] text-[14px]')

export const M12 = styled(NativeText, 'font-[JioType-Medium] text-[12px]')

export const M10 = styled(NativeText, 'font-[JioType-Medium] text-[10px]')

export const M8 = styled(NativeText, 'font-[JioType-Medium] text-[8px]')

export const B14 = styled(
  NativeText,
  'font-[JioType-Bold] text-[14px] font-bold',
)

export const B16 = styled(
  NativeText,
  'font-[JioType-Bold] text-[16px] font-bold',
)

export const B18 = styled(
  NativeText,
  'font-[JioType-Bold] text-[18px] font-bold',
)

export const B26 = styled(
  NativeText,
  'font-[JioType-Black] text-[26px] font-black',
)

export const B36 = styled(
  NativeText,
  'font-[JioType-Black] text-[36px] font-black',
)

export const S12 = styled(NativeText, 'font-[JioType] text-[12px] font-medium')

export const S10 = styled(NativeText, 'font-[JioType] text-[10px] font-medium')

export const R12 = styled(NativeText, 'font-[JioType] text-[12px] font-regular')

export const R10 = styled(NativeText, 'font-[JioType] text-[10px] font-regular')

export const R14 = styled(NativeText, 'font-[JioType] text-[14px] font-regular')

export const B12 = styled(
  NativeText,
  'font-[JioType-Bold] text-[12px] font-bold',
)
